export default __webpack_public_path__ + "static/media/0B070498-40B8-4F22-ADAA-9EC86282833F_1_105_c.fd0c50f5.jpeg";